module.exports = __webpack_public_path__ + "static/leaflet2026-4a369ee6d20a028a6f7d9d6cbff3aaf3.pdf";